import { FlagsmithProviders } from '@mint-lib/flags-envs';

import { useSuspenseFlags } from '../hooks/useSuspenseFlags.js';

export function flagBasedComponent(
  flagName: string,
  env: keyof typeof FlagsmithProviders,
  FlagComponent: React.ComponentType,
  FallbackComponent: React.ComponentType,
) {
  return () => {
    const flag = useSuspenseFlags(env, [flagName])[flagName].enabled;
    return flag ? <FlagComponent /> : <FallbackComponent />;
  };
}
